import {
	type EmptyProfile,
	type EventType,
	type Profile,
	useMeProfileGetMeProfile,
} from '@cocoonspace/api'
import { useCallback } from 'react'
import { useCopyClipboard } from '@cocoonspace/shared/hooks/use-copy-clipboard.hook'
import { useLingui } from '@lingui/react/macro'
import { LinkIcon } from 'lucide-react'
import { toast } from 'sonner'

import { ScheduleCardActionBtn } from '../../scheduling-card'

const isProfile = (profile: EmptyProfile | Profile): profile is Profile =>
	!('isEmpty' in profile)

export const CopyLinkAction = ({ eventType }: { eventType: EventType }) => {
	const { t } = useLingui()
	const { copyToClipboard } = useCopyClipboard()
	const { data: meProfile } = useMeProfileGetMeProfile()
	const profile = meProfile && isProfile(meProfile) ? meProfile : undefined

	const copyUrl = useCallback(() => {
		const origin = window.location.origin
		const isPublic = profile?.eventTypeIds?.includes(eventType.id)
		const userSlug = profile?.slug
		const eventTypeId = eventType.id

		const url = isPublic
			? `${origin}/${userSlug}/${eventTypeId}`
			: `${origin}/scheduling/${eventTypeId}`

		return copyToClipboard(url).then(() => {
			toast.success(t`URL copiée`)
		})
	}, [
		copyToClipboard,
		eventType.id,
		t,
		profile?.slug,
		profile?.eventTypeIds,
	])

	return (
		<ScheduleCardActionBtn
			title={t`Copier l'URL`}
			onClick={copyUrl}
		>
			<LinkIcon />
		</ScheduleCardActionBtn>
	)
}
